import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, catchError, map, of, switchMap, tap } from 'rxjs';
import { StorageService } from '../service/storage.service';
import { UuidService } from '../service/uuid.service';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../service/loader.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
 userData: any;
  constructor(
    public storageService: StorageService, 
    public loader: LoaderService,
    public uuidService: UuidService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.loader.setLoading(true);
    this.storageService.getItem('local','authData').subscribe(user => 
      this.userData = user
    );
    const isApiUrl = request.url.startsWith(environment.apiBaseUrl);
    
    let headers = request.headers;
    
    // Add UUID header for all API requests (even before login)
    if (isApiUrl) {
      headers = headers.set('device_id', this.uuidService.getUuid());
    }
    
    // Add language header for GET requests
    if (request.method === 'GET') {
      headers = headers.set('X-Return-Lang', 'all');
    }
    
    if (this.userData && isApiUrl) {
      headers = headers.set('Authorization', `Bearer ${this.userData.token}`);
    }
    
    request = request.clone({ headers });
    
    return next.handle(request).pipe(
      map((evt: HttpEvent<any>) => {
        if(evt instanceof HttpResponse){
          this.loader.setLoading(false);
        }
        return evt;
      })
    );
  }
}
